import React, {createContext, useCallback, useContext, useEffect, useMemo, useState} from 'react';
import {getEdgeConfigAndTemplates} from '../services/statisticsApi';
import {buildChartsConfig} from '../utils/chartBuilder';

const ChartConfigContext = createContext();

export const ChartConfigProvider = ({children, edgeId}) => {
  const [chartsConfig, setChartsConfig] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadChartsConfig = useCallback(async () => {
    if (!edgeId) return;

    setLoading(true);
    setError(null);

    const result = await getEdgeConfigAndTemplates(edgeId);

    if (!result.ok) {
      setError(result.error);
      setChartsConfig(null);
      setLoading(false);
      return;
    }

    const {config, templates, isLegacy} = result.data;
    const chartsConf = isLegacy ? config : buildChartsConfig(config, templates);

    setChartsConfig(chartsConf);
    setLoading(false);
  }, [edgeId]);

  useEffect(() => {
    if (!edgeId) return;
    loadChartsConfig();
  }, [edgeId, loadChartsConfig]);

  const value = useMemo(() => ({
    edgeId,
    chartsConfig,
    loading,
    error,
    reloadChartsConfig: loadChartsConfig,
  }), [edgeId, chartsConfig, loading, error, loadChartsConfig]);

  return <ChartConfigContext.Provider value={value}>{children}</ChartConfigContext.Provider>;
};

export const useChartConfig = () => {
  const context = useContext(ChartConfigContext);
  if (!context) {
    throw new Error('useChartConfig must be used within ChartConfigProvider');
  }
  return context;
};

